// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3I1cm","header":"ReportDetails_header__2Q0kY","title":"ReportDetails_title__1oD6B","left":"ReportDetails_left__3DUS2"};